<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>{{ body }} </mat-dialog-content>
<mat-dialog-actions>
  <button class="mat-raised-button" (click)="close()">
    {{ "train.accept" | translate }}
  </button>
</mat-dialog-actions>
